import { html } from "lit";
import { ProductFootnotesTemplate } from "./blocks/ProductFootnotes.templates";
import { MoreInfoBlock } from "./blocks/product-detail-moreinfo.templates";
import { HeroSliderZoomableTemplate } from "./blocks/product-detail-hero.templates";
import { TabAccessories } from "./blocks/product-detail-accessories.templates";
import { TabApplications } from "./blocks/product-detail-applications.templates";
import { TabDeliveryscope } from "./blocks/product-detail-deliveryscope.templates";
import { TabOverview } from "./blocks/product-detail-overview.templates";
import { TabTechnicaldata } from "./blocks/product-detail-technicaldata.templates";
import { TabSoftware } from "./blocks/product-detail-software.templates";

interface TabItem {
    id: string;
    label: string;
    template: () => unknown;
}

const tabs: TabItem[] = [
    {
        id: "tabOverview",
        label: "Überblick",
        template: TabOverview,
    },
    {
        id: "tabApplications",
        label: "Anwendungen",
        template: TabApplications,
    },
    {
        id: "tabTechnicaldata",
        label: "Technische Daten",
        template: TabTechnicaldata,
    },
    {
        id: "tabDeliveryscope",
        label: "Lieferumfang",
        template: TabDeliveryscope,
    },
    {
        id: "tabAccessories",
        label: "Zubehör",
        template: TabAccessories,
    },
    {
        id: "tabSoftware",
        label: "Software",
        template: TabSoftware,
    },
];

const renderTab = (tab: TabItem) => html`
    <!-- BEGIN Tab ${tab.id} -->
    <ux-tab
        name="${tab.label}"
        tab-id="tab-${tab.id}"
        data-tracking-context="tab"
        data-tracking-value="${tab.id}"
        class="ux-u-margin-top-60 ux-u-margin-bottom-60"
    >
        ${tab.template()}
    </ux-tab>
    <!-- END Tab ${tab.id} -->
`;

export const Template = () => {
    return html`
        <div
            class="frame frame-default frame-type-trumpfpim_productdetails frame-layout-0"
        >
            <!-- Hero Slider Zoomable-->
            ${HeroSliderZoomableTemplate()}

            <!-- Shop Overlay -->
            <div class="product-shop shop-overlay is-hidden">
                <div
                    id="price-loader-accessories"
                    class="myTrumpf myTrumpf-loader"
                >
                    <div class="loader"></div>
                </div>
                <span class="close-span">
                    <div>
                        <span class="is-closeShop">
                            <p>Schließen</p>
                            <i class="icon-close" data-grunticon-embed=""></i>
                        </span>
                    </div>
                </span>
            </div>

            <!-- Product Detail Tabs -->
            <ux-tab-container
                scroll-when-activated
                class="ux-u-margin-top-25 ux-u-margin-l-top-40"
            >
                ${tabs.map((tab) => renderTab(tab))}
            </ux-tab-container>

            <!-- Footnotes -->
            ${ProductFootnotesTemplate({})}
        </div>

        <!-- Spacer -->
        <div class="ux-u-mt-fluid-m"></div>

        ${MoreInfoBlock()}
    `;
};
